/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './image-crop.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/image-crop/image-crop.component';
const styles_ImageCropComponent:any[] = [i0.styles];
export const RenderType_ImageCropComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ImageCropComponent,data:{}});
export function View_ImageCropComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{imgEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['img',
      1]],(null as any),0,'img',[['class','img-responsive img']],[[8,'src',4]],(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:i2.ImageCropComponent = _v.component;
    const currVal_0:any = _co.src;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ImageCropComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-image-crop',
      ([] as any[]),[[2,'fade',(null as any)]],(null as any),(null as any),View_ImageCropComponent_0,
      RenderType_ImageCropComponent)),i1.ɵdid(4898816,(null as any),0,i2.ImageCropComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).bgFade;
    _ck(_v,0,0,currVal_0);
  });
}
export const ImageCropComponentNgFactory:i1.ComponentFactory<i2.ImageCropComponent> = i1.ɵccf('admin-image-crop',
    i2.ImageCropComponent,View_ImageCropComponent_Host_0,{src:'src',aspectRatio:'aspectRatio',
        setSelect:'setSelect',bgColor:'bgColor',bgOpacity:'bgOpacity',bgFade:'bgFade'},
    {change:'change'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ltYWdlLWNyb3AvaW1hZ2UtY3JvcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvaW1hZ2UtY3JvcC9pbWFnZS1jcm9wLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ltYWdlLWNyb3AvaW1hZ2UtY3JvcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ltYWdlLWNyb3AvaW1hZ2UtY3JvcC5jb21wb25lbnQudHMuSW1hZ2VDcm9wQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGltZyBbc3JjXT1cInNyY1wiICNpbWcgY2xhc3M9XCJpbWctcmVzcG9uc2l2ZSBpbWdcIj4iLCI8YWRtaW4taW1hZ2UtY3JvcD48L2FkbWluLWltYWdlLWNyb3A+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUE7TUFBQTs7SUFBSztJQUFMLFdBQUssU0FBTDs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtJQUFBO0lBQUEsV0FBQSxTQUFBOzs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/image-crop/image-crop.component.ngfactory.ts